import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["ref"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Flex } from '@chakra-ui/react';
import { Controller } from 'react-hook-form';
import { jsx as _jsx } from "react/jsx-runtime";
export default function FormDynamicField(_ref) {
  var _formField$props, _errors$formField$nam;
  var control = _ref.control,
    formField = _ref.formField,
    errors = _ref.errors,
    handleSetValue = _ref.handleSetValue,
    handleResetField = _ref.handleResetField,
    handleSetError = _ref.handleSetError,
    handleClearErrors = _ref.handleClearErrors,
    handleTriggerValidation = _ref.handleTriggerValidation,
    getValues = _ref.getValues,
    reset = _ref.reset;
  var errorStyles = formField !== null && formField !== void 0 && (_formField$props = formField.props) !== null && _formField$props !== void 0 && _formField$props.useTooltip && !!(errors !== null && errors !== void 0 && (_errors$formField$nam = errors[formField.name]) !== null && _errors$formField$nam !== void 0 && _errors$formField$nam.message) ? tooltipErrorStyles : {};
  return _jsx(Flex, _objectSpread(_objectSpread({
    direction: "column"
  }, _objectSpread(_objectSpread(_objectSpread({}, defaultStyles), formField.styles), errorStyles)), {}, {
    "data-fieldname": formField.name,
    children: _jsx(Controller, {
      name: formField.name,
      control: control,
      render: _ref2 => {
        var field = _ref2.field;
        var _ = field.ref,
          extraPropsField = _objectWithoutProperties(field, _excluded);
        return _jsx(Box, {
          "data-testid": formField.testid,
          children: !!formField.Component && _jsx(formField.Component, {
            formField: formField,
            field: extraPropsField,
            control: control,
            errors: errors,
            handleSetValue: handleSetValue,
            handleResetField: handleResetField,
            handleSetError: handleSetError,
            handleClearErrors: handleClearErrors,
            handleTriggerValidation: handleTriggerValidation,
            getValues: getValues,
            reset: reset
          })
        });
      }
    })
  }));
}
var defaultStyles = {
  marginBottom: 'var(--chakra-space-md)'
};
var tooltipErrorStyles = {
  marginBottom: 'var(--chakra-space-6xl)'
};